import { Box } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { LinearProgressBar } from "components/atoms/LinearProgressBar";

export const MiniDisinfectionModes = ({
  row: { autonomous, remoteControlled, stationary },
}: GridRenderCellParams) => {
  const totalCount = autonomous + remoteControlled + stationary;

  return (
    <Box style={{ width: "100%" }}>
      <LinearProgressBar
        sx={{ height: "6px", marginBottom: "2px" }}
        value={totalCount === 0 ? 0 : (autonomous / totalCount) * 100}
      />
      <LinearProgressBar
        sx={{ height: "6px", marginBottom: "2px" }}
        value={totalCount === 0 ? 0 : (remoteControlled / totalCount) * 100}
      />
      <LinearProgressBar
        sx={{ height: "6px" }}
        value={totalCount === 0 ? 0 : (stationary / totalCount) * 100}
      />
    </Box>
  );
};
